export const limitCustomerData = customerData => {
    if (!customerData) return undefined;

    const limitedColors = customerData.metadata?.colors
        ? {
              primaryColor: customerData.metadata.colors.primaryColor,
              secColor: customerData.metadata.colors.secColor,
          }
        : undefined;

    const limitedOtherInformation = customerData?.metadata?.otherInformation
        ? {
              browser: customerData.metadata.otherInformation.browser,
              version: customerData.metadata.otherInformation.version,
              os: customerData.metadata.otherInformation.os,
              platform: customerData.metadata.otherInformation.platform,
              source: customerData.metadata.otherInformation.source,
          }
        : undefined;

    const limitedMetadata = customerData?.metadata
        ? {
              environment: customerData.metadata.environment,
              merchantName: customerData.metadata.merchantName,
              showSuccessBtnOnDone: customerData.metadata.showSuccessBtnOnDone,
              type: customerData.metadata.type,
              colors: limitedColors,
              otherInformation: limitedOtherInformation,
          }
        : undefined;

    return {
        id: customerData.id,
        first_name: customerData.first_name,
        last_name: customerData.last_name,
        email: customerData.email,
        phone: customerData.phone,
        reference: customerData.reference,
        metadata: limitedMetadata,
    };
};
